import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button/constants';
import { OverflowPageButton } from './OverflowPageButton';
import { PaginationButton, PaginationButtons } from './Styled';
import { PageButtonProps, PaginationVariant } from './types';

const generatePage = (
  page: number,
  key: number,
  currentPage: number,
  onChangePage: (page: number) => void,
  pageVariant: PaginationVariant,
) => {
  const handleClick = () => {
    onChangePage(page);
  };
  return (
    <PaginationButton
      variant={BUTTON_VARIANTS.SECONDARY}
      size={BUTTON_SIZES.SMALL}
      key={`page-${page}`}
      onClick={handleClick}
      isDisabled={currentPage === page}
      pageVariant={pageVariant}
    >
      {page}
    </PaginationButton>
  );
};

export const PageButtons = ({
  page,
  pages,
  onChangePage,
  maxPages,
  pageVariant = PaginationVariant.Purple,
}: PageButtonProps) => {
  const padding = Math.floor(maxPages / 2);
  const pageArray = [];
  const showAllPages = pages <= maxPages;

  let hasOverflowBefore = false;
  let hasOverflowAfter = false;
  let min;

  if (page - padding < 2 || showAllPages) {
    min = 1;
    hasOverflowAfter = maxPages < pages;
  } else if (page + padding >= pages) {
    min = pages - maxPages + 1;
    hasOverflowBefore = min > 1;
  } else {
    min = page - padding;
    hasOverflowBefore = true;
    hasOverflowAfter = true;
  }

  /**
   * Without having a minimum of 1 page, the previous and next buttons show, but
   * the page button does not.  This makes sure that at least the button for
   * page 1 shows, even if there are no rows.
   */
  const numberOfPages = Math.max(showAllPages ? pages : maxPages, 1);

  for (let i = 0; i < numberOfPages; i += 1) {
    if (i === 0) {
      pageArray.push(generatePage(1, i, page, onChangePage, pageVariant));
    } else if (i === numberOfPages - 1) {
      pageArray.push(generatePage(pages, i, page, onChangePage, pageVariant));
    } else if ((i === 1 && hasOverflowBefore) || (i === numberOfPages - 2 && hasOverflowAfter)) {
      pageArray.push(
        <OverflowPageButton pageVariant={pageVariant} key={`page-overflow-${i}-${page}`} />,
      );
    } else {
      pageArray.push(generatePage(i + min, i, page, onChangePage, pageVariant));
    }
  }

  return <PaginationButtons>{pageArray}</PaginationButtons>;
};
